const ContactDetails = ({ address1, address2, email, phones }) => {
    return (
        <section className="contact-details">
            <div className="container">
                <div className="row">

                    <div className="col-md-4">
                        <div className="single-c-details-item">
                            <div className="icon">
                                <i className="fas fa-map-marker-alt"></i>
                            </div>
                            <div className="content">
                                <h4>Visit us</h4>
                                <p>
                                    {address1} <br />
                                    {address2}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="single-c-details-item">
                            <a href={`mailto:${email}`} className="icon" aria-label="email">
                                <i className="fas fa-envelope"></i>
                            </a>
                            <div className="content">
                                <h4>Email us</h4>
                                <p>
                                    <a href={`mailto:${email}`}>{email}</a>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="single-c-details-item">
                            <a href={`tel:${phones?.[0]?.link}`} className="icon" aria-label="phone">
                                <i className="fas fa-phone-alt"></i>
                            </a>
                            <div className="content">
                                <h4>Call us</h4>
                                {phones?.map((p, i) => (
                                    <p key={i} className="mb-0">
                                        <a href={`tel:${p.link}`}>{p.number}</a>
                                    </p>
                                ))}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default ContactDetails;
